import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const TOGGLE_LEGEND = 'legend/TOGGLE_LEGEND';
const TOGGLE_TYPE = 'legend/TOGGLE_TYPE';

const TOGGLE_ICON = 'legend/TOGGLE_ICON';
// const SET_TIME = 'app/SET_TIME';
// const POKE_MY_BRANCHES = 'app/POKE_MY_BRANCKES';
// const POKE_MY_ITEMS = 'app/POKE_MY_ITEMS';

export const toggleLegend = createAction(TOGGLE_LEGEND, () => null);

export const toggleType = createAction(TOGGLE_TYPE, (type: string) => ({
  type,
}));

export const toggleIcon = createAction(TOGGLE_ICON, (type: string) => ({
  type,
}));
// export const setTime = createAction(SET_TIME, (ISOTime: string) => ISOTime);
// export const pokeMyBranches = createAction(POKE_MY_BRANCHES, () => null);
// export const pokeMyItems = createAction(POKE_MY_ITEMS, () => null);

const initialState = {
  // user: {},
  // time: new Date(),
  // tick_myBranches: '',
  // tick_myItems: '',
  show: true,
  exclude: [],
  done: {},
  // locale: 'ko',
};

export default handleActions(
  {
    [TOGGLE_LEGEND]: (state: any, { payload }: any) =>
      produce(state, (draft) => {
        // const { locale } = payload;
        draft.show = !draft.show;
      }),
    [TOGGLE_TYPE]: (state: any, { payload }: any) =>
      produce(state, (draft) => {
        const { type } = payload;
        if (draft.exclude.indexOf(type) !== -1) {
          draft.exclude = draft.exclude.filter((e: string) => e !== type);
        } else {
          draft.exclude = [...draft.exclude, type];
        }
        // draft.show = !draft.show;
      }),
    [TOGGLE_ICON]: (state: any, { payload }: any) =>
      produce(state, (draft) => {
        const { type } = payload;
        draft.done[type] = !draft.done[type];
        // draft.show = !draft.show;
      }),
  },
  initialState,
);
